import React from 'react';
import {
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio,
  Stack, TextField, Collapse, Typography, Autocomplete
} from '@mui/material';

const AMBER_GROUPS = [
  "Baltic amber",
  "Burmese amber",
  "Dominican amber",
  "Mexican amber",
  "Canadian amber",
  "New Jersey amber",
  "French amber",
  "Spanish amber",
  "Lebanese amber",
  "Taimyr amber",
  "Fushun amber",
  "Oise amber",
  "Charentese amber",
  "Rovno amber",
  "Bitterfeld amber",
  "Sakhalin amber"
];

const GEOLOGICAL_ERAS = [
  "Holocene", "Pleistocene", "Pliocene", "Miocene", "Oligocene", "Eocene", "Paleocene",
  "Cretaceous", "Jurassic", "Triassic",
  "Permian", "Carboniferous", "Devonian", "Silurian", "Ordovician", "Cambrian"
];

export default function SectionExtantFossil({ form, handleChange }) {
  const status = form.extant_fossil || 'unknown';

  return (
    <Stack spacing={2}>
      <FormControl component="fieldset">
        <FormLabel component="legend">Status</FormLabel>
        <RadioGroup
          row
          value={status}
          onChange={(e) => handleChange('extant_fossil', e.target.value)}
        >
          <FormControlLabel value="unknown" control={<Radio />} label="Unknown" />
          <FormControlLabel value="extant" control={<Radio />} label="Extant" />
          <FormControlLabel value="fossil" control={<Radio />} label="Fossil" />
        </RadioGroup>
      </FormControl>

      <Collapse in={status === 'fossil'}>
        <Stack spacing={2} sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1, mt: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">Fossil Details</Typography>
          
          <FormControl component="fieldset">
            <FormLabel component="legend" sx={{ fontSize: '0.85rem' }}>Fossil Type</FormLabel>
            <RadioGroup
              row
              value={form.fossil_type || 'other'}
              onChange={(e) => handleChange('fossil_type', e.target.value)}
            >
              <FormControlLabel value="amber" control={<Radio size="small" />} label={<Typography variant="body2">Amber</Typography>} />
              <FormControlLabel value="compression" control={<Radio size="small" />} label={<Typography variant="body2">Compression/Impression</Typography>} />
              <FormControlLabel value="other" control={<Radio size="small" />} label={<Typography variant="body2">Other</Typography>} />
            </RadioGroup>
          </FormControl>

          {form.fossil_type === 'amber' && (
            <Autocomplete
              freeSolo
              options={AMBER_GROUPS}
              value={form.amber_group || ''}
              onChange={(event, newValue) => handleChange('amber_group', newValue)}
              onInputChange={(event, newInputValue) => handleChange('amber_group', newInputValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Amber Group"
                  helperText="e.g. Baltic, Burmese, Dominican"
                  size="small"
                  fullWidth
                />
              )}
            />
          )}

          <Autocomplete
            freeSolo
            options={GEOLOGICAL_ERAS}
            value={form.geological_era || ''}
            onChange={(event, newValue) => handleChange('geological_era', newValue)}
            onInputChange={(event, newInputValue) => handleChange('geological_era', newInputValue)}
            renderInput={(params) => (
              <TextField {...params} label="Geological Era / Stratigraphy" helperText="e.g. Eocene, Cretaceous, etc." size="small" fullWidth />
            )}
          />

          <TextField
            label="Age (MYA)"
            value={form.fossil_age_mya || ''}
            onChange={(e) => handleChange('fossil_age_mya', e.target.value)}
            helperText="Millions of years ago (e.g. 99)"
            size="small"
            type="number"
            fullWidth
          />
        </Stack>
      </Collapse>
    </Stack>
  );
}